import { Component, OnInit, Input, TemplateRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'projection-for-device',
    templateUrl: './projection-for-device.shared.component.html',
})
export class ProjectionForDeviceComponent implements OnInit {
    //
    //  Initial asumption based on first designs and items about mobile/desktop devices was ok
    //  Using just media queries would work both for this component and for css, so many elements
    //  assume that mobile device is anything with screen width lower than 768px...
    //  After a while this project got fat, no patterns, designs were shitty - these guys don't know what is grid...
    //
    //  Mobile device assumptions should be aligned with touch event detection, thus lots of components need to be refactored.
    //  Also some css media queries will require rethinking.
    //
    @Input() public mobile: TemplateRef<any> = null;
    @Input() public desktop: TemplateRef<any> = null;

    public isDeviceSet$: Observable<boolean>;
    public isMobile$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) {
        this.isDeviceSet$ = this.controllers.appSettings.deviceType$()
            .pipe(
                map(device => device !== null),
            );

        this.isMobile$ = this.controllers.appSettings.deviceType$()
            .pipe(
                map(device => device === OLO.Enums.DEVICE_TYPE.MOBILE)
            );
    }

    ngOnInit(): void { }
}
